import classNames from 'classnames'
import { CSSProperties, forwardRef, JSX, PropsWithChildren } from 'react'

import { splitSprinkleProps } from '@/styles/split-sprinkle-props'

import { sprinkles, Sprinkles } from '@/styles/sprinkles.css'

export const Text = forwardRef<HTMLSpanElement, TextProps>(function Text(props, ref) {
  const [sprinkleProps, { as = 'p', className, style, inline, ellipsis, children, ...restProps }] = splitSprinkleProps<TextProps>(props)
  const ellipsisProps = ellipsis ? ({ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } as const) : undefined
  const As = (inline ? 'span' : as) as any
  return (
    <As
      ref={ref}
      style={style}
      className={classNames(sprinkles({ ...sprinkleProps, ...ellipsisProps }), className)}
      {...restProps}
    >
      {children}
    </As>
  )
})

export interface TextProps extends Sprinkles, PropsWithChildren {
  as?: keyof JSX.IntrinsicElements
  className?: string
  style?: CSSProperties
  inline?: boolean
  ellipsis?: boolean
}
